import { createCommands } from '@tdp/common/commandHandler';
import { ILogger } from '@tdp/common/telemetry';

import { ISettingsService } from './abstractions/ISettingsService';
import { settingsSlice } from './slice';

export interface CreateSettingsCommandHandlerDependencies {
  logger: ILogger;
  settingsService: ISettingsService
}
export const createSettingsCommandHandler = ({
  settingsService,
}: CreateSettingsCommandHandlerDependencies) =>
  createCommands({
    name: 'settingsCommands',
    handlers: {
      async *getTenantSettings() {
        const tenantSettingsResponse = await settingsService.getTenantSettings();
        if (tenantSettingsResponse.type === 'error') {
          yield settingsSlice.actions.resetTenantSettings();
        } else {
          yield settingsSlice.actions.setTenantSettings(tenantSettingsResponse.tenantSettings);
        }
      },
    },
  });
